import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged, Subscription } from 'rxjs';

import { ToolsService } from 'src/app/services/tools/tools.service';
import { CssService } from 'src/app/services/css-service';
import { RubricService } from 'src/app/services/api/rubric/rubric.service';
import { ProductService } from 'src/app/services/api/product/product.service';

import { FullePointOfSaleService } from 'src/app/services/api/fulle/fulle-pointOfSale/fulle-pointOfSale.service';
import { PointOfSaleSummary } from 'src/app/services/api/fulle/fulle-pointOfSale/fulle-pointOfSale.service.interface';
import { OrderContext } from '../fulle-product/fulle-product.interface';
import { SaleMethod } from '../fulle-selection-SM/fulle-selection-SM.interface';
import { LogoAndBannerService } from 'src/app/services/fulle/logoAndBanner/logoAndBanner.service';
import { SMV2Rubrics } from './fulle-product-v2.interface';
import { FulleProductService } from 'src/app/services/api/fulle/fulle-product/fulle-product.service';
import { PricePeriod } from 'src/app/services/api/fulle/fulle-product/fulle-product.interface';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MediaObserver } from "@angular/flex-layout";
import * as _ from 'lodash';
import { ProdComponent } from "src/app/components/dialogs/prod/prod.component";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: 'app-fulle-product-v2',
  templateUrl: './fulle-product-v2.component.html',
})
export class FulleProductV2Component implements OnInit, OnDestroy {
  loader = true;
  loaderMessage: string | null = null;

  merchantName = '';
  webshopId = '';
  smId!: number;
  posId = 0;

  idMerchant!: number;
  orderContext: OrderContext = {
    webshopId: '',
    idMerchant: 0,
    posId: 0,
    saleMethodId: -1,
    dateOrder: '',
    hourOrder: ''
  }

  currPos!: PointOfSaleSummary;
  currSM: SaleMethod | null = null;

  // UI state
  searchCtrl = new FormControl<string>('', { nonNullable: true });
  private subSearch?: Subscription;

  selectedRubricId: string | number = 'all';

  // data
  rubrics: any[] = [];
  displayRubrics: any[] = [];
  newRubricsDisplay: any[] = []; // rubriques filtrées (all ou single)
  products: any[] = [];

  // pagination
  limitTo = 50;
  limitFrom = 0;
  moreProductsButton = true;

  // optional (si tu utilises pricePeriods / stocks via resolver avant)
  pricePeriods: PricePeriod[] = [];

  //test
  showSearchInput = false; // Affichage de l'input de recherche
  findedProducts: any[] | null = null;
  merchantClient: any = null;       // ce que tu avais avant (client/merchant)
  loaderpop = false; // Loader secondaire (ex: chargement popup)
  statusMessage: any = null; // Message de statut (ex: "chargement..." en popup)
  toggleBasketResp = false; // Affichage du panier (mobile)
  searchProductLoader = false; // Loader de la recherche
  toggleRubBar = true; // Affichage de la barre de rubriques
  windowWidth: number = window.innerWidth;
  rubrics$: any; // Toutes les rubriques (catégories de produits)
  products$: any[] = [];            // ou LegacyProductVM[]
  newRubricsDisplay$: any; // Rubriques filtrées (recherche, promo, etc.)
  user_: any = null;
  $count = 0; // Total des produits récupérables
  $more_products_button = true; // Affichage du bouton "voir plus"
  $limit_from = 0; // Index de départ
  scrollingElementProd: any; // Scroll produit pour détecter les interactions
  closeSearch = false;              // si ton sidenav l’utilise


  constructor(
    private route: ActivatedRoute,
    protected router: Router,

    protected tools: ToolsService,
    public cssService: CssService,


    private fullePosApi: FullePointOfSaleService,

    private rubApi: RubricService,
    private fulleprodApi: FulleProductService,
    private logoAndBannerService: LogoAndBannerService,

    //test
    public media: MediaObserver,
    public dialog: MatDialog,
    private prodApi: ProductService,
    public translate: TranslateService,

  ) { }

  ngOnInit(): void {
    const params = this.route.snapshot.params;
    this.merchantName = params['merchantName'];
    this.webshopId = params['webshopId'];
    this.smId = Number(params['smId']);
    // console.log("this.merchantName : ", this.merchantName);
    // console.log("this.webshopId : ", this.webshopId);
    // console.log("this.smId : ", this.smId);

    // Périodes de prix
    this.pricePeriods = this.route.snapshot.data['pricePeriods'];
    // console.log("this.pricePeriods ngOnInit : ", this.pricePeriods);

    this.init();

    // recherche (debounce)
    this.subSearch = this.searchCtrl.valueChanges
      .pipe(debounceTime(350), distinctUntilChanged())
      .subscribe(value => {
        const quote = (value ?? '').trim();
        if (quote.length === 0) {
          this.resetSearch();
          return;
        }
        if (quote.length < 3) return; // comme ton legacy
        this.searchProducts(quote);
      });
  }

  ngOnDestroy(): void {
    if (this.subSearch) this.subSearch.unsubscribe();
  }

  private async init(): Promise<void> {
    this.loader = true;
    this.loaderMessage = 'Chargement...';

    try {
      // 1) order_context
      this.orderContext = this.tools.getStor('order_context');
      // console.log("this.orderContext : ", this.orderContext);
      if (!this.orderContext) {
        // On revient a la selection de SM
        this.router.navigate(['/s', this.merchantName, this.webshopId]);
        return;
      }

      // 2) POS : depuis storage sinon via Slim summary
      this.currPos = this.tools.getStor('point_of_sale');
      // console.log("this.currPos : ", this.currPos);
      if (!this.currPos) {
        if (this.orderContext) {
          const posList = await this.fullePosApi.getPointOfSaleSummary(this.orderContext.idMerchant, '', 'timetables');
          const pos = (posList ?? []).find(x => String(x.idWebshop) === String(this.webshopId));
          if (!pos) {
            this.router.navigate(['/s', this.merchantName, this.webshopId]);
            return;
          }
          this.currPos = pos;
          this.fullePosApi.setPoint(this.currPos); // on remplace dans le storage par la version slim
        }
      }
      this.logoAndBannerService.initLogoAndBannerSummary(this.currPos).then((enrichedPoint: PointOfSaleSummary) => {
        if (enrichedPoint) {
          this.currPos = enrichedPoint;
        }
      });

      // 3) Load rubrics + first page products
      await this.loadRubrics();
      await this.loadProductsPage(true);

      this.loader = false;
      this.loaderMessage = null;
    } catch (e) {
      console.error("erreur : ", e);
      this.router.navigate(['/s', this.merchantName, this.webshopId]);
    }
  }

  // -------- Rubrics --------

  private async loadRubrics(): Promise<void> {
    if (!this.currPos) return;

    this.loaderMessage = 'Chargement des rubriques...';
    const posIdForRubrics = this.orderContext.posId ?? this.currPos.id

    // RubricService est observable dans ton legacy
    const rubs = await new Promise<any[]>((resolve) => {
      this.rubApi.getRubricsBySm(this.smId, posIdForRubrics).subscribe((rubric: SMV2Rubrics[]) => {
        // console.log("rubric : ", rubric);
        resolve(rubric ?? []);
      });
    });

    // tu avais un pipeline setRubricsFavorite / setRubricsPricePeriod / setRubrics etc.
    // ici V1: on garde simple => setRubrics(rubs) si tu as, sinon direct
    const rubsParsed = this.rubApi.setRubrics ? this.rubApi.setRubrics(rubs) : rubs;

    this.rubrics = rubsParsed;
    ////// TEST //////
    this.rubrics$ = this.rubrics;          // contrat pour <app-rub-prod-list>
    this.newRubricsDisplay$ = this.rubrics$;
    this.products$ = [];                   // optionnel, mais évite undefined
    //////////////////
    this.displayRubrics = (rubsParsed ?? []).filter((rubric: any) => rubric.id_parent === 0);

    // état affichage initial
    this.selectedRubricId = 'all';
    this.newRubricsDisplay = this.rubrics;
  }

  selectRubric(rubricId: string | number): void {
    this.selectedRubricId = rubricId;
    this.limitFrom = 0;

    // reset produits puis reload
    void this.loadProductsPage(true);
  }

  // -------- Products --------
  private async loadProductsPage(reset: boolean): Promise<void> {
    if (!this.currPos) return;

    const rubricId = this.selectedRubricId === 'all' ? 'all' : this.selectedRubricId;

    this.loaderMessage = 'Chargement des produits...';

    const prodData: any = await this.fulleprodApi.getProducts(
      this.smId,
      reset ? 0 : this.limitFrom,
      rubricId,
      null,
      reset ? 'start' : null,
      this.pricePeriods
    );
    // console.log("prodData : ", prodData);

    // const incoming = prodData?.products ?? [];

    // if (reset) {
    //   this.products = incoming;
    // } else {
    //   this.products = [...this.products, ...incoming];
    // }

    ////// TEST //////
    const incoming = prodData?.products ?? [];

    // garde une copie flat si tu veux (debug / autres usages)
    this.products = reset ? incoming : [...this.products, ...incoming];
    this.products$ = this.products;

    // ✅ IMPORTANT : attache les produits aux rubriques (comme le legacy)
    const rubsWithProds = this.rubApi.addProdtoRubrics
      ? this.rubApi.addProdtoRubrics(this.rubrics$, incoming, reset)
      : this.rubrics$;

    // met à jour la source pour <app-rub-prod-list>
    this.rubrics$ = rubsWithProds;

    // affichage all vs une rubrique (contrat legacy)
    this.newRubricsDisplay$ = (rubricId === 'all')
      ? this.rubrics$
      : [this.rubrics$.find((x: any) => x.id == rubricId)].filter(Boolean);

    // sync des vars legacy attendues par le composant
    this.$count = prodData?.num_rows ?? this.$count;
    this.$more_products_button = !(prodData?.products_to_display > prodData?.num_rows);
    this.$limit_from = prodData?.next_limit_from ?? this.limitFrom;

    // pagination
    this.moreProductsButton = this.$more_products_button;
    this.limitFrom = prodData?.next_limit_from ?? (this.limitFrom + this.limitTo);

    /////////////////

    this.moreProductsButton = prodData?.products_to_display > prodData?.num_rows ? false : true;
    this.limitFrom = prodData?.next_limit_from ?? (this.limitFrom + this.limitTo);

    // filtrage rubriques affichées (legacy : all vs one rubric)
    this.newRubricsDisplay = rubricId === 'all'
      ? this.rubrics
      : [this.rubrics.find((x: any) => x.id == rubricId)].filter(Boolean);

    this.loaderMessage = null;
  }

  // moreProducts(rub?: any): void {
  //   // ton composant rub-prod-list te renvoie rub, sinon on utilise selectedRubricId
  //   void this.loadProductsPage(false);
  // }

  moreProducts(rub?: any): void {
    if (rub?.id) {
      this.selectedRubricId = rub.id;
    }
    void this.loadProductsPage(false);
  }


  // -------- Search --------

  // async searchProducts(query: string): Promise<void> {

  //   // on force rubric = all en recherche (comme souvent)
  //   this.selectedRubricId = 'all';
  //   this.limitFrom = 0;

  //   this.loaderMessage = 'Recherche...';

  //   const prodData: any = await this.fulleprodApi.getProducts(
  //     this.smId,
  //     0,
  //     'all',
  //     query,
  //     false,
  //     this.pricePeriods ?? null
  //   );

  //   this.products = prodData?.products ?? [];
  //   this.moreProductsButton = false; // généralement pas de load more en search V1

  //   this.loaderMessage = undefined;
  // }

  async searchProducts(query: string): Promise<void> {
    this.searchProductLoader = true;
    this.loaderMessage = 'Recherche...';

    try {
      const prodData: any = await this.fulleprodApi.getProducts(
        this.smId,
        0,
        'all',
        query,
        false,
        this.pricePeriods ?? null
      );

      this.findedProducts = prodData?.products ?? [];
      // en recherche, on masque le "voir plus" sur la liste rubriques
      this.$more_products_button = false;
      this.moreProductsButton = false;
    } finally {
      this.searchProductLoader = false;
      this.loaderMessage = null;
    }
  }

  // resetSearch(): void {
  //   if (this.searchCtrl.value.trim().length) {
  //     this.searchCtrl.setValue('');
  //   }
  //   this.selectedRubricId = 'all';
  //   this.limitFrom = 0;
  //   void this.loadProductsPage(true);
  // }

  resetSearch(): void {
    if (this.searchCtrl.value.trim().length) {
      this.searchCtrl.setValue('');
    }
    this.findedProducts = null;      // ✅ re-bascule sur rub-prod-list
    this.selectedRubricId = 'all';
    this.limitFrom = 0;
    void this.loadProductsPage(true);
  }


  // -------- Dialog product (placeholder) --------
  openProd(prod: any): void {
    // V1: tu brancheras ton dialog produit ensuite
    // console.log('open prod', prod);
  }

  // test

  openProdDial(prod: any, from: string, index?: number): void {
    const myConf = new MatDialogConfig();
    //on copie scrollPositionY à l'ouverture
    // this.copyscrollPositionY = _.cloneDeep(this.scrollPositionY);
    // Hide input recherche en xs
    this.showSearchInput = false;
    this.findedProducts = null;
    if (this.media.isActive("xs")) {
      myConf.panelClass = "full-screen";
    } else {
      myConf.width = prod.product_type === 2 ? "780px" : "450px";
    }
    myConf.autoFocus = false;
    // recupere les cats par produits
    myConf.data = {
      index: index,
      from: from,
      prod: prod,
      categories: []
    };
    prod.product_type > 0 ? this.getcatProd(myConf, prod) :
      this.openDialProdComp(myConf);
  }

  getcatProd(myConf: any, prod: any) {
    this.loaderpop = true;
    this.statusMessage = "Récupération des catégories";
    this.statusMessage = this.translate.instant('loaderCats')
    // this.prodCatSub = this.prodcatApi.getApiProdCatsByIdProd(prod).subscribe((cats) => {
    //   cats = this.checkCategories(cats);
    //   myConf.data.prod.categories = cats;
    //   myConf.data.prod.novisible = myConf.data.prod.categories && myConf.data.prod.categories.length > 0 ? false : true
    //   myConf.data.categories = cats;
    //   // this.loaderpop = false;
    //   // this.statusMessage = null;
    //   this.openDialProdComp(myConf);
    // });
  }

  checkCategories(cats: any) {
    const newCats: any = [];
    if (cats && cats.length > 0) {
      cats.forEach((element: any) => {
        const detailsCats: any = []
        if (element && element.details && element.details.length > 0) {
          element.details.forEach((details: any) => {
            if (details.product && details.product.product_type < 2) {
              detailsCats.push(details);
            }
          });
          if (detailsCats && detailsCats.length > 0) {
            element.details = detailsCats;
            newCats.push(element);
          }
        }
      });
    }
    return newCats;
  }

  // ouvre la dialog product
  openDialProdComp(myConf: any) {
    myConf.data.merchantClient = this.merchantClient ? this.merchantClient : null;
    const myDial = this.dialog.open(ProdComponent, myConf);
    myDial.afterClosed().subscribe((result) => {
      if (result) {
        //check if products suggested
        this.prodApi.checkProductsSuggestions(result, this.merchantClient);
      }
      this.checkPopOpen(myDial.getState())
    });
    this.checkPopOpen(myDial.getState())
  }

  // ======== checkPopOpen ========
  checkPopOpen(data?: any) {
    // this.popClosed = !data ? false : true;
    this.toggleBasketResp = true;
    setTimeout(() => {
      this.tools.setOnPopState();
    }, 0);
  }

  // ======== si user deconnecté après connexion ========
  deconnection() {
    if (this.tools.checkCurrentPage("product")) {
      setTimeout(() => {
        window.location.reload();
      }, 0);
    }
  }

  setShowSearchInput(value: boolean): void {
    this.showSearchInput = value;
  }

  // Increment le tableau de recherche de produit
  setFindedProducts(value: any[] | null): void {
    // console.log("fulle-product.component - setFindedProducts - value : ", value);
    this.findedProducts = value;
  }

  setSearchProductLoader(value: boolean): void {
    this.searchProductLoader = value;
  }

  // Le sidenav te demande un reset "produits"
  resetSearchProduct(): void {
    this.resetSearch(); // si tu as déjà resetSearch() comme dans le legacy
  }

  // Le sidenav te remonte une requête de recherche
  searchProduct(query: string): void {
    void this.searchProducts(query); // ta fonction async existante
  }

  // Ouvrir le panier (adapter à ta logique)
  openBasket(): void {
    // 1) si tu as un service panier:
    // this.panierService.open();
    // 2) sinon simple toggle:
    this.toggleBasketResp = !this.toggleBasketResp;
  }

}
